import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import Config from '../../Core/Config.js';
import {framework} from 'saffroncodejs';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import {libs,ui} from 'saffroncodejs';
var PageManager = framework.PageManager ;
class Pezeshkan extends React.Component {
    constructor(props) {
        super(props);
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);
        this.state = {
            isLoading:true,
            activeTab: 1,
            data:{"UserId":"60b62129-b2d5-4db8-a275-e19bc5faa7fc","UserTypeBaseId":"23","UserTypeBaseTitle":null,"UserTypeLanguageBaseId":0,"FirstName":"مریم","LastName":"مالکی","EMailAddress":"maryam_22_11_66@yahoo.com","MobileNo":"09127012470","UserName":"maryam","Password":null,"IsActive":"True","Version":null,"ConfirmNumber":null,"IsConfirmed":"True","IsBlocked":false,"BlockedNote":null,"PhotoName":"","AcceptedPhotos":"","WonPhotos":"","BirthDate":"","GenderTypeBaseId":"32","GenderTypeLanguageBaseId":0,"GenderTypeBaseTitle":"","AllLikeCount":"0","CityId":"1","Adress":"تهران","TotalPhotos":"0","TotalRefereeScore":"0","AuthorizedSurveyIds":null,"Description":"کاربر تستی","PostalCode":"0078436893","IsPictureConfirmed":null}
        }
        this.state.data = {} ;
        
        this.state.btns=[];
       
       this.loadDetail();
            
    }

    encodeSodurId(encodedId)
    {
        return encodedId;
    }

    componentWillReceiveProps(props)
    {
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);

        this.loadDetail();
    }

    loadDetail()
    {
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Ms/api/MsPez/PolicyInfo",
           
                {id: this.currentSodurId, codeMelli:  UserManager.MelliCode()}
            ),
            BimeManager.header())
            .then((result)=>{
                this.setState({data:result.data,isLoading:false})
                console.log('Pezeshkan: ', this.state.data)
            })
            .catch((error) => { alert(error) })   
    }

    pagechange(bid,reshte) {
        
        PageManager.changePage(Config.p_pardakhtman,[bid,reshte]);
    }
   
    render() {
        
        return (

            <div>
               <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>مسئولیت حرفه ای پزشکان</h4>
                    </Col>
                </Row>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 1 }}
                            onClick={() => { this.setState({activeTab:1}) }}>
                            جزئیات
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 2 }}
                            onClick={() => { this.setState({activeTab:2}) }}>
                            الحاقیه
                        </NavLink>
                    </NavItem>
                       
                    <NavItem>
                        <NavLink onClick={() => {this.pagechange(this.currentSodurId,this.state.data.Reshte)}}>
                            پرداخت شده ها
                        </NavLink>
                    </NavItem>
                </Nav>
               

{ (!this.state.isLoading)?(
        
         
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={1}>
                        <Row>
                            <Col sm="12">
                                <div className="container ListOfList">
                                    <Row>
                                        <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه:</span>{this.state.data.BId}</Col>
                                        <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{this.state.data.FullBNo}</Col>
                                        <Col sm="12"><span className="bold-head">شماره بیمه نامه قبلی:</span>{this.state.data.LastBNO}</Col>
                                        <Col sm="12"><span className="bold-head">تاریخ صدور بیمه نامه:</span>{this.state.data.BnSodurDate}</Col>
                                        <Col sm="12"><span className="bold-head">نماینده/کارگزار:</span>{this.state.data.AgentCodeText}</Col>
                                        <Col sm="12"><span className="bold-head">بیمه گذار:</span>{this.state.data.BimeGozarPrintName}</Col>
                                        <Col sm="12"><span className="bold-head">شماره شناسنامه:</span>{this.state.data.IdentityNo}</Col>
                                        <Col sm="12"><span className="bold-head">سال تولد:</span>{this.state.data.BirthYear}</Col>
                                        <Col sm="12"><span className="bold-head">تخصص:</span>{this.state.data.ProficiencyName}</Col>
                                        <Col sm="12"><span className="bold-head">شماره نظام پزشكي:</span>{this.state.data.NezamPezeshki}</Col>
                                        <Col sm="12"><span className="bold-head">شماره ملي:</span>{this.state.data.CodeMelli}</Col>
                                        <Col sm="12"><span className="bold-head">نشاني منزل:</span>{this.state.data.BGAddress}</Col>
                                        <Col sm="12"><span className="bold-head">تلفن منزل:</span>{this.state.data.BGTel}</Col>
                                        <Col sm="12"><span className="bold-head">نشانی مطب:</span>{this.state.data.MatabAddress}</Col>
                                        <Col sm="12"><span className="bold-head">نشانی بیمارستان:</span>{this.state.data.DarmaniCenterAddress}</Col>
                                        <Col sm="12"><span className="bold-head">نوع بیمه گذار:</span>{this.state.data.CustomerKindText}</Col>
                                        <Col sm="12"><span className="bold-head">کد پستی:</span>{this.state.data.BGCodePosti}</Col>
                                        <Col sm="12"><span className="bold-head">مدت:</span>{this.state.data.Moddat}</Col>
                                        <Col sm="12"><span className="bold-head">تاریخ شروع:</span>{this.state.data.BeginDate}</Col>
                                        <Col sm="12"><span className="bold-head">تاریخ پایان:</span>{this.state.data.EndDate}</Col>
                                        <Col sm="12"><span className="bold-head">حداکثر تعهد بيمه گر برای هر نفر در طول مدت  بيمه نامه:</span>{libs.StringFunctions.currancyPrint(this.state.data.BNHaramMonthSarmaye)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">حداکثر تعهد بیمه گر غرامت فوت و نقص عضو براي هر نفر در هر حادثه:</span>{libs.StringFunctions.currancyPrint(this.state.data.HaramMonthSarmaye)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">حق بيمه:</span>{libs.StringFunctions.currancyPrint(this.state.data.HB)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">حق بيمه به حروف:</span>{this.state.data.HBText}</Col>
                                        <Col sm="12"><span className="bold-head">ماليات بر ارزش افزوده:</span>{libs.StringFunctions.currancyPrint(this.state.data.AfzoodehMaliat)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">عوارض شهرداري:</span>{libs.StringFunctions.currancyPrint(this.state.data.ShahrdariAvarez)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">مبلغ قابل پرداخت به عدد:</span>{libs.StringFunctions.currancyPrint(this.state.data.HBKol)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">مبلغ قابل پرداخت به حروف:</span>{this.state.data.HBKolText}</Col>
                                        <Col sm="12"><span className="bold-head">واحد صدور:</span>{this.state.data.CodeSodurText}</Col>
                                        <Col sm="12"><span className="bold-head">نشاني واحد صدور:</span>{this.state.data.SodurAddressText}</Col>
                                        <Col sm="12"><span className="bold-head">تلفن واحد صدور:</span>{this.state.data.SodurTel}</Col>
                                        <Col sm="12"><span className="bold-head">کد ملی:</span>{this.state.data.CodeMelli}</Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>

                    <TabPane tabId={2}>
                        <Row>
                            <Col sm="12">
                                <div className="container ListOfList">
                                    <Row>
                                        {
                                            //alert('bill***'+this.state.data.Bill)
                                          (this.state.data.Endorsement)?  this.state.data.Endorsement.map((endorsement)=>{
                                            return <div className="border-List">
                                                            <Col sm="12"><span className="bold-head">نوع بیمه نامه:</span>{endorsement.NoeBimename}</Col>
                                                            <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه:</span>{endorsement.BId}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{endorsement.FullBNO}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{endorsement.ElhNo}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره ردیف سالانه:</span>{endorsement.Radif}</Col>
                                                            <Col sm="12"><span className="bold-head">تاریخ صدور:</span>{endorsement.ElhSodurDate}</Col>
                                                            <Col sm="12"><span className="bold-head">تاریخ اعمال:</span>{endorsement.ElhActiveDate}</Col>
                                                            <Col sm="12"><span className="bold-head">ساعت صدور:</span>{endorsement.SodurTime}</Col>
                                                            <Col sm="12"><span className="bold-head">معرف/کارگزار:</span>{endorsement.AgentCodeText}</Col>
                                                            <Col sm="12"><span className="bold-head">بیمه گذار:</span>{endorsement.BimeGozarText}</Col>
                                                            <Col sm="12"><span className="bold-head">واحد صدور:</span>{endorsement.CodeSodurText}</Col>
                                                            <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{endorsement.Sharh}</Col>
                                                            <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{libs.StringFunctions.currancyPrint(endorsement.ShahrdariAvarez)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">مالیات بر ارزش افزوده:</span>{libs.StringFunctions.currancyPrint(endorsement.AfzoodehMaliat)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه اضافی:</span>{libs.StringFunctions.currancyPrint(endorsement.EzafiHBValue)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه برگشتی:</span>{libs.StringFunctions.currancyPrint(endorsement.BargashtiHBValue)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه اضافی با مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.EzafiHBKolValue)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه برگشتی با مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.BargashtiHBKolValue)+('ریال')}</Col>
                                                           <br/>
                                                          </div>
                                                
                                            }):''
                                        }
                                            
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>

            

                </TabContent>):(<ui.Preloader />)
                
            
            
         }
         </div>
        );
    }
}


export default Pezeshkan;


// WEBPACK FOOTER //
// ./src/components/ListCollapse/Pezeshkan.js